import type { ReactNode } from 'react';
import { HeatPumpEnergyFlow, LaminarFlowSVG, AnnualCostChart, CumulativeCostChart } from '@system-rec/decision-ui';
import { ControlsModulationChart } from '../print/ControlsModulationChart';
import { EnergyLossesGraphic } from '../print/EnergyLossesGraphic';
import { HeatOutputChart } from '../print/HeatOutputChart';
import { PipeworkFlowChart } from '../print/PipeworkFlowChart';
import { YPlanValve } from './visuals/YPlanValve';
import { SPlanValve } from './visuals/SPlanValve';
import { SealedVsOpenVented } from './visuals/SealedVsOpenVented';
import { HydraulicSeparation } from './visuals/HydraulicSeparation';
import { PowerFlush } from './visuals/PowerFlush';
import { LongevityDiagram } from './visuals/LongevityDiagram';
import { ColdMainsPerformance } from './visuals/ColdMainsPerformance';
import { RegularVsSystemBoiler } from './visuals/RegularVsSystemBoiler';
import { CombiMainsFlow } from './visuals/CombiMainsFlow';
import { UnventedCylinderDiagram } from './visuals/UnventedCylinderDiagram';

const visualMap: Record<string, ReactNode> = {
  // Existing print/chart components
  PipeworkFlowChart: <PipeworkFlowChart width={560} height={280} />,
  EnergyLossesGraphic: <EnergyLossesGraphic width={560} height={280} />,
  ControlsModulationChart: <ControlsModulationChart width={560} height={280} />,
  HeatOutputChart: <HeatOutputChart width={560} height={280} />,

  // Cost comparison charts (from decision-ui)
  AnnualCostChart: <AnnualCostChart data={[]} />,
  CumulativeCostChart: <CumulativeCostChart data={[]} />,

  // Animated components from decision-ui
  HeatPumpEnergyFlow: <HeatPumpEnergyFlow animated />,
  LaminarFilter: <LaminarFlowSVG />,

  // System layout animations
  YPlanValve: <YPlanValve />,
  SPlanValve: <SPlanValve />,
  SealedVsOpenVented: <SealedVsOpenVented />,
  HydraulicSeparation: <HydraulicSeparation />,

  // Maintenance & longevity
  PowerFlush: <PowerFlush />,
  LongevityDiagram: <LongevityDiagram />,

  // Cold mains & water supply
  ColdMainsPerformance: <ColdMainsPerformance />,
  RegularVsSystemBoiler: <RegularVsSystemBoiler />,
  CombiMainsFlow: <CombiMainsFlow />,
  UnventedCylinderDiagram: <UnventedCylinderDiagram />,
};

export function renderExplainerVisual(componentKey?: string): ReactNode | null {
  if (!componentKey) return null;
  return visualMap[componentKey] ?? null;
}
